// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qudvztcondkuuiqjascx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1ZHZ6dGNvbmRrdXVpcWphc2N4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3OTI2MzUsImV4cCI6MjA2OTM2ODYzNX0.n50ptvWH7mQ2qTGSs_POGyMNcK96SkNHTe4Ub-YZHK0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});